__turbopack_context__.v({
  "className": "open_sans_f112325-module__UUyQLa__className",
  "variable": "open_sans_f112325-module__UUyQLa__variable",
});
